// src/services/cmsService.js
import api from './apiClient.js';

const cmsService = {
    async getPages() {
        const response = await api.get('/pages');
        return response.data;
    },

    async getPageBySlug(slug) {
        const response = await api.get(`/pages/${slug}`);
        return response.data;
    },

    async updateSection(slug, sectionKey, data) {
        const response = await api.put(`/pages/${slug}/sections/${sectionKey}`, { "data": data });
        return response.data;
    },

    async toggleSectionVisibility(slug, sectionKey, isVisible) {
        const response = await api.put(`/pages/${slug}/sections/${sectionKey}/visibility`, { isVisible });
        return response.data;
    }
};

export default cmsService;